import { parallax } from "jquery-parallax.js";

export default function() {
  const widgetName = 'cardWidgetHomepageBackground';
  const widgetOpts = cardWidgetHomepageBackgroundOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const image = data.items[0].ImageWithPath;

      // $('.section-tier-two').prepend(`<div class="parallax" data-parallax-image="${image}">`);
      // console.log(universalParallax)
      // new universalParallax().init();
      $('.tier-two-mobile-bg').attr('data-background-image', image);
      $('.section-tier-two').parallax(
        {imageSrc: image,
          bleed: 100
        });
        $('.parallax-slider').attr('alt', 'altimg');
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: false,
      margin: 10,
      navText: ['Prev','Next'],
      nav: false
    },
    textOverImage: false
  });

}